/**
 * colors.js
 * CORES OFICIAIS FLEET PREMIUM v3.0
 *
 * Use APENAS estas cores em todo o sistema.
 * Importar: import { COLORS, DARK, LIGHT } from '../theme/colors';
 *
 * Inspirado em: Linear App, GitHub Dark, Vercel
 */

// =============================================================================
// CONSTANTES DE CORES - DARK MODE (Principal)
// =============================================================================

export const DARK = {
  // BACKGROUNDS (do mais escuro ao mais claro)
  bg: {
    base: '#0d1117',       // Fundo principal da aplicacao
    raised: '#161b22',     // Cards, sidebar, panels
    elevated: '#1c2128',   // Modais, dropdowns, popovers
    hover: '#21262d',      // Hover em items de lista
    active: '#30363d',     // Item ativo/selecionado
    sunken: '#010409',     // Areas rebaixadas
  },

  // TEXT
  text: {
    primary: '#f0f6fc',    // Titulos, texto principal
    secondary: '#8b949e',  // Labels, texto auxiliar
    muted: '#6e7681',      // Placeholders, disabled
    disabled: '#484f58',   // Texto desabilitado forte
    inverse: '#0d1117',    // Texto em fundo claro (botoes)
    link: '#58a6ff',       // Links
    linkHover: '#79b8ff',  // Links hover
  },

  // BORDERS
  border: {
    subtle: 'rgba(255, 255, 255, 0.04)',   // Bordas muito sutis
    default: 'rgba(255, 255, 255, 0.08)',  // Bordas padrao
    strong: 'rgba(255, 255, 255, 0.16)',   // Bordas destacadas
    divider: 'rgba(255, 255, 255, 0.06)',  // Divisores
    focus: '#00d4aa',                       // Focus ring
  },

  // ACCENT (Teal - cor principal da marca)
  accent: {
    primary: '#00d4aa',                     // Cor principal
    hover: '#00e4ba',                       // Hover
    active: '#00c49a',                      // Active/pressed
    muted: 'rgba(0, 212, 170, 0.15)',       // Background sutil
    subtle: 'rgba(0, 212, 170, 0.08)',      // Background muito sutil
    glow: 'rgba(0, 212, 170, 0.4)',         // Glow effect
  },

  // STATUS DE VEICULOS
  status: {
    online: '#00d4aa',                      // Verde teal - conectado
    onlineBg: 'rgba(0, 212, 170, 0.15)',
    offline: '#6e7681',                     // Cinza - desconectado
    offlineBg: 'rgba(110, 118, 129, 0.15)',
    moving: '#58a6ff',                      // Azul - em movimento
    movingBg: 'rgba(88, 166, 255, 0.15)',
    idle: '#d29922',                        // Amarelo - parado/ocioso
    idleBg: 'rgba(210, 153, 34, 0.15)',
    stopped: '#8b949e',                     // Cinza claro - parado
    stoppedBg: 'rgba(139, 148, 158, 0.15)',
    alarm: '#f85149',                       // Vermelho - alarme
    alarmBg: 'rgba(248, 81, 73, 0.15)',
    maintenance: '#a371f7',                 // Roxo - manutencao
    maintenanceBg: 'rgba(163, 113, 247, 0.15)',
    unknown: '#484f58',                     // Cinza escuro - desconhecido
  },

  // SEMANTIC (feedback do sistema)
  semantic: {
    success: '#00d4aa',
    successBg: 'rgba(0, 212, 170, 0.15)',
    error: '#f85149',
    errorBg: 'rgba(248, 81, 73, 0.15)',
    warning: '#d29922',
    warningBg: 'rgba(210, 153, 34, 0.15)',
    info: '#58a6ff',
    infoBg: 'rgba(88, 166, 255, 0.15)',
  },

  // CHARTS (10 cores para graficos)
  chart: [
    '#00d4aa', // Teal (principal)
    '#58a6ff', // Azul
    '#a371f7', // Roxo
    '#d29922', // Amber
    '#f97316', // Laranja
    '#f85149', // Vermelho
    '#3fb950', // Verde
    '#79c0ff', // Azul claro
    '#bc8cff', // Roxo claro
    '#e3b341', // Amarelo
  ],
};

// =============================================================================
// CONSTANTES DE CORES - LIGHT MODE
// =============================================================================

export const LIGHT = {
  // BACKGROUNDS
  bg: {
    base: '#ffffff',
    raised: '#f6f8fa',
    elevated: '#ffffff',
    hover: '#f3f4f6',
    active: '#e5e7eb',
    sunken: '#f0f1f3',
  },

  // TEXT
  text: {
    primary: '#1f2328',
    secondary: '#656d76',
    muted: '#8b949e',
    disabled: '#b0b8c1',
    inverse: '#ffffff',
    link: '#0969da',
    linkHover: '#0550ae',
  },

  // BORDERS
  border: {
    subtle: 'rgba(0, 0, 0, 0.04)',
    default: 'rgba(0, 0, 0, 0.08)',
    strong: 'rgba(0, 0, 0, 0.16)',
    divider: 'rgba(0, 0, 0, 0.06)',
    focus: '#00b894',
  },

  // ACCENT (Teal mais escuro para contraste)
  accent: {
    primary: '#00b894',
    hover: '#00a884',
    active: '#009874',
    muted: 'rgba(0, 184, 148, 0.15)',
    subtle: 'rgba(0, 184, 148, 0.08)',
    glow: 'rgba(0, 184, 148, 0.3)',
  },

  // STATUS (mesmas cores, bom contraste)
  status: {
    online: '#00b894',
    onlineBg: 'rgba(0, 184, 148, 0.15)',
    offline: '#6b7280',
    offlineBg: 'rgba(107, 114, 128, 0.15)',
    moving: '#2563eb',
    movingBg: 'rgba(37, 99, 235, 0.15)',
    idle: '#d97706',
    idleBg: 'rgba(217, 119, 6, 0.15)',
    stopped: '#6b7280',
    stoppedBg: 'rgba(107, 114, 128, 0.15)',
    alarm: '#dc2626',
    alarmBg: 'rgba(220, 38, 38, 0.15)',
    maintenance: '#7c3aed',
    maintenanceBg: 'rgba(124, 58, 237, 0.15)',
    unknown: '#9ca3af',
  },

  // SEMANTIC
  semantic: {
    success: '#00b894',
    successBg: 'rgba(0, 184, 148, 0.15)',
    error: '#dc2626',
    errorBg: 'rgba(220, 38, 38, 0.15)',
    warning: '#d97706',
    warningBg: 'rgba(217, 119, 6, 0.15)',
    info: '#2563eb',
    infoBg: 'rgba(37, 99, 235, 0.15)',
  },

  // CHARTS
  chart: [
    '#00b894',
    '#2563eb',
    '#7c3aed',
    '#d97706',
    '#ea580c',
    '#dc2626',
    '#16a34a',
    '#3b82f6',
    '#8b5cf6',
    '#ca8a04',
  ],
};

// =============================================================================
// CONSTANTES FLAT (para uso rapido)
// =============================================================================

export const COLORS = {
  // Backgrounds
  BG_BASE: DARK.bg.base,
  BG_RAISED: DARK.bg.raised,
  BG_ELEVATED: DARK.bg.elevated,
  BG_HOVER: DARK.bg.hover,
  BG_ACTIVE: DARK.bg.active,

  // Text
  TEXT_PRIMARY: DARK.text.primary,
  TEXT_SECONDARY: DARK.text.secondary,
  TEXT_MUTED: DARK.text.muted,

  // Accent (Teal)
  ACCENT: DARK.accent.primary,
  ACCENT_HOVER: DARK.accent.hover,
  ACCENT_MUTED: DARK.accent.muted,
  ACCENT_SUBTLE: DARK.accent.subtle,

  // Status
  STATUS_ONLINE: DARK.status.online,
  STATUS_OFFLINE: DARK.status.offline,
  STATUS_MOVING: DARK.status.moving,
  STATUS_IDLE: DARK.status.idle,
  STATUS_ALARM: DARK.status.alarm,
  STATUS_MAINTENANCE: DARK.status.maintenance,

  // Semantic
  SUCCESS: DARK.semantic.success,
  ERROR: DARK.semantic.error,
  WARNING: DARK.semantic.warning,
  INFO: DARK.semantic.info,

  // Borders
  BORDER_SUBTLE: DARK.border.subtle,
  BORDER_DEFAULT: DARK.border.default,
  BORDER_STRONG: DARK.border.strong,

  // Glassmorphism presets (valores, nao objetos!)
  GLASS_BG_LIGHT: 'rgba(22, 27, 34, 0.6)',
  GLASS_BG_MEDIUM: 'rgba(22, 27, 34, 0.75)',
  GLASS_BG_HEAVY: 'rgba(22, 27, 34, 0.9)',
  GLASS_BLUR: 'blur(16px)',
};

// =============================================================================
// DEPRECATED - NAO USAR ESTAS CORES
// =============================================================================
// #232323 -> usar DARK.bg.raised (#161b22)
// #353535 -> usar DARK.bg.hover (#21262d)
// #fff para texto -> usar DARK.text.primary (#f0f6fc)
// #3B82F6 -> usar DARK.semantic.info (#58a6ff)
// #4CAF50 -> usar DARK.semantic.success (#00d4aa)
// #FF3637 -> usar DARK.semantic.error (#f85149)

// =============================================================================
// HELPER FUNCTIONS
// =============================================================================

/**
 * Retorna a paleta correta baseada no modo
 * @param {boolean} darkMode - true para dark, false para light
 */
export const getPalette = (darkMode = true) => (darkMode ? DARK : LIGHT);

/**
 * Retorna cor com fallback seguro
 * @param {string} color - Cor a usar
 * @param {string} fallback - Fallback se color for undefined
 */
export const safeColor = (color, fallback) => color || fallback;

export default COLORS;
